import { extraSmall } from './sizes/extraSmall';
import { small } from './sizes/small';
import { medium } from './sizes/medium';
import { large } from './sizes/large';
import { megaLarge } from './sizes/megaLarge';
import { custom } from './sizes/custom';

const inputStyleFactory = (size, obj) => {
  switch (size) {
    case 'extraSmall':
      return extraSmall();
    case 'small':
      return small();
    case 'medium':
      return medium();
    case 'large':
      return large();
    case 'megaLarge':
      return megaLarge();
    case 'custom':
      return custom(obj);
    default:
      return medium();
  }
};

export { inputStyleFactory };
